export default "__VITE_ASSET__DiYCg_CW__"